interface FilterRowMetaLike {
  label: string;
  payloadField: string;
}

interface FilterRowValueLike {
  expanded?: boolean;
  chips?: { id: string | number }[];
}

type CikisiFieldValue = (string | number)[] | boolean;

export function buildCikisiFields(
  isCikisiUser: boolean,
  cikisiOnlyKey: string,
  cikisiOnly: boolean,
  knowledgeBase: boolean,
  filterRowMeta: FilterRowMetaLike[],
  filterRows: FilterRowValueLike[],
): Record<string, CikisiFieldValue> {
  if (!isCikisiUser) return {};

  const fields: Record<string, CikisiFieldValue> = {
    [cikisiOnlyKey]: cikisiOnly,
    knowledge_base: knowledgeBase,
  };

  filterRowMeta.forEach((meta, i) => {
    const row = filterRows[i];
    const active = !!row?.expanded;
    fields[meta.payloadField] = active ? (row?.chips ?? []).map(opt => opt.id) : [];
  });

  return fields;
}
